import { render, staticRenderFns } from "./PointBankTelecom.vue?vue&type=template&id=e30485ea"
import script from "./PointBankTelecom.vue?vue&type=script&lang=js"
export * from "./PointBankTelecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports